import React from "react";
import PropTypes from "prop-types";
import './Button.css'
import { images } from "../../assets";

function Button({ buttonText, className, arrowClassName, onClick }) {
    return (
      <button className={className} onClick={onClick}>
        {buttonText} <img className={arrowClassName} src={images.arrowRight} alt="Arrow" />
      </button>
    );
  }
  
  Button.propTypes = {
    buttonText: PropTypes.string.isRequired,
    className: PropTypes.string,
    arrowClassName: PropTypes.string,
    onClick: PropTypes.func 
  };
  
  export default Button;
